import {
  getHotelExtraData,
  getHotelBasicData,
  getFlightBasicData,
  getFlightExtraData,
  getHotelPax,
  getFlightPax,
} from "./ProductDataSelection";
import {
  getActivityBasicData,
  getActivityExtraData,
  getActivityPax,
} from "./ProductDataSelection/activityDataSelection";
import {
  getFerryBasicData,
  getFerryExtraData,
  getFerryPax,
} from "./ProductDataSelection/ferryDataSelection";
import {
  getTrainBasicData,
  getTrainExtraData,
  getTrainPax,
} from "./ProductDataSelection/trainDataSelection";
import {
  getTransferBasicData,
  getTransferExtraData,
  getTransferPax,
} from "./ProductDataSelection/transferDataSelection";
import {
  getCarRentalBasicData,
  getCarRentalExtraData,
  getCarRentalPax,
} from "./ProductDataSelection/carRentalDataSelection";

export function getProductBasicData({ productType, reservation, t }) {
  switch (productType) {
    case "ACC":
      return getHotelBasicData({ reservation, t });
    case "FL":
      return getFlightBasicData({ reservation, t });
    case "TRF":
      return getTransferBasicData({ reservation, t });
    case "ACT":
      return getActivityBasicData({ reservation, t });
    case "FER":
      return getFerryBasicData({ reservation, t });
    case "TRA":
      return getTrainBasicData({ reservation, t });
    case "CAR":
      return getCarRentalBasicData({ reservation, t });
    default:
      return [];
  }
}

export function getProductExtraData({ productType, reservation, t }) {
  switch (productType) {
    case "ACC":
      return getHotelExtraData({ reservation, t });
    case "FL":
      return getFlightExtraData({ reservation, t });
    case "TRF":
      return getTransferExtraData({ reservation, t });
    case "ACT":
      return getActivityExtraData({ reservation, t });
    case "FER":
      return getFerryExtraData({ reservation, t });
    case "TRA":
      return getTrainExtraData({ reservation, t });
    case "CAR":
      return getCarRentalExtraData({ reservation, t });
    default:
      return [];
  }
}

export function getProductPax({ productType, reservation, t }) {
  switch (productType) {
    case "ACC":
      return getHotelPax({ reservation, t });
    case "FL":
      return getFlightPax({ reservation, t });
    case "TRF":
      return getTransferPax({ reservation, t });
    case "ACT":
      return getActivityPax({ reservation, t });
    case "FER":
      return getFerryPax({ reservation, t });
    case "TRA":
      return getTrainPax({ reservation, t });
    case "CAR":
      return getCarRentalPax({ reservation, t });
    default:
      return [];
  }
}
